module.exports = __webpack_public_path__ + "img/IMG_3539_L_Wood.91c45896.jpg";